import { MemreButton, MemreFlexBox } from 'components/core';
import React, { ChangeEvent, useRef } from 'react';
import { createVideo } from 'utils/createVideo';

export default function Video({ add, url }) {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleButtonClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = async (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files.length > 0) {
      const video = await createVideo(event.target.files[0]);
      add(video.url, video.id);
    }
  };


  return (
    <>
      <input
        type="file"
        style={{ display: 'none' }}
        accept="video/mp4,video/webm,video/ogg,video/avi,video/mov,video/wmv"
        onChange={handleFileChange}
        ref={fileInputRef}
      />
      {!url && (
        <MemreButton text="Add Video" iconName="video" variant="outlined" size="small" onClick={handleButtonClick} />
      )}
      {url && (
        <MemreFlexBox direction="column" gap={1} sx={{ width: '100%', maxWidth: '500px' }}>
          <video
            controls
            style={{ width: '100%', maxHeight: '300px', borderRadius: '4px' }}
          >
            <source src={url} />
            Your browser does not support the video tag.
          </video>
        </MemreFlexBox>
      )}
    </>
  );
}